import { render } from "./returngoods.vue?vue&type=template&id=776f454b"
import script from "./returngoods.vue?vue&type=script&lang=js"
export * from "./returngoods.vue?vue&type=script&lang=js"

import "./returngoods.vue?vue&type=style&index=0&id=776f454b&lang=less"

import exportComponent from "F:\\ffile\\vscodeprj\\app\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__